/* eslint-disable no-useless-catch */
/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useMemo, useState } from "react";
import { db } from "~/db/db";
import { useGetProspectCarteira } from "~pages/Wallet/hooks/useWallet";
import { useLiveQuery } from "dexie-react-hooks";

const useProspect = (id) => {
  const [prospect, setProspect] = useState();
  const [enabledGetProspect, setEnabledGetProspect] = useState(false);

  const getProspect = useLiveQuery(() => {
    return id && id != "undefined" ? db.prospect.get(parseInt(id)) : null;
  }, [id])

  async function fetchCarteira() {
    if (id && id !== "undefined") {
      setEnabledGetProspect(true)
    }

    if (getProspect) {
      setProspect(getProspect);
    }
  }

  async function setProspectCarteira(prospect) {
    if (prospect) {
      const prospectLocal = await db.prospect.get(prospect.id);
      await db.prospect.put({ ...prospectLocal, ...prospect });
      fetchCarteira();

      const clienteLocal = await db.cliente.get(prospect.id);
      await db.cliente.put({ ...clienteLocal, ...prospect });
    }
  }

  const useRemoveCallback = () => {
    return useMemo(() => {
        return async () => {
            try {
                return await db.prospect.where({id: parseInt(id)}).delete();
            } catch (error) {
              throw error
            }
        };
    }, []);
  };

  const prospectRequest = useGetProspectCarteira(id, enabledGetProspect)

  useEffect(() => {
    if(getProspect && Object.entries(getProspect).length > 0 && getProspect.id) {
      setProspect(getProspect)
    }
  }, [getProspect]);

  useEffect(() => {
    if (prospectRequest.data) {
      setProspectCarteira(prospectRequest.data)
      fetchCarteira();
    }
  }, [prospectRequest.data])

  useEffect(() => {
    fetchCarteira();
  }, [])

  useEffect(() => {
    fetchCarteira();
  }, [id])

  return {
    prospect,
    setProspectCarteira,
    useRemoveCallback
  };
}

export default useProspect;
